import React from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from '../../dynamicComponent';
import {Form, Grid, Header} from 'semantic-ui-react';
import {
  InlineSelect,
  InlineTextBoxField,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import STATE_OPTIONS from 'app-ui-componentlibrary/dist/common/states';
import _ from 'lodash';
import {onlyAllowNumbers} from 'common/utils';
import {produceAppliedDiff} from 'framework/collaboration/diff.utils';

export class AddressInfo extends React.Component {
  constructor(props) {
    super(props);
    const address = {};
    this.state = {
      model: address,
    };
  }

  componentDidMount() {
    if (!_.isEmpty(this.props.data)) {
      this.setState({model: this.props.data});
    }
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.data, this.props.data)) {
      if (this.props.currentlyCollaborating) {
        this.setState((prevState) => ({
          model: produceAppliedDiff(prevProps.data, this.props.data, prevState?.model),
        }));
        return;
      }
      this.setState({model: this.props.data});
    }
  }

  saveAddressInfo = (fieldName) => {
    const {saveEntityData, validationId} = this.props;
    const address = this.state.model;

    saveEntityData(
      this.props.entityDataPath,
      this.props.entityType,
      address,
      validationId + '.' + fieldName
    );
  };

  render() {
    const {validationDirtyMap, validationErrors, config} = this.props;
    const findError = (field) => {
      const errs = _.get(_.get(validationErrors, 0), field);
      if (errs instanceof Array) {
        return _.find(errs, (err) => !err.isValid);
      }
      return errs;
    };

    const displayError = (field) => _.get(findError(field), 'isValid') === false;
    const errorMessage = (field) => _.get(findError(field), 'message');
    const isDirty = (field) => {
      const dirtyField = _.get(validationDirtyMap, ['dirty', field], false);
      return dirtyField || (_.get(validationDirtyMap, 'dirtyPage', false) && !dirtyField);
    };
    const handleChange = (name, value) => {
      let model = _.cloneDeep(this.state.model);
      _.set(model, name, value);
      this.setState({model});
    };
    const title = this.props.title || 'Address';

    return (
      <Form>
        <Header as="h4">{title}</Header>
        <hr />
        <InlineTextBoxField
          id="mainAddress1"
          title="Address 1"
          label="Address 1"
          name="address1"
          size="large"
          value={_.get(this.state.model, 'address1')}
          maxLength={81}
          handleChange={(e) => handleChange(e.target.name, e.target.value)}
          handleBlur={() => this.saveAddressInfo('address1')}
          displayError={isDirty('address1') && displayError('address1')}
          errorMessages={errorMessage('address1')}
        />
        <InlineTextBoxField
          id="mainAddress2"
          title="Address 2"
          label="Address 2"
          optional="true"
          size="large"
          name="address2"
          value={_.get(this.state.model, 'address2')}
          maxLength={81}
          handleChange={(e) => handleChange(e.target.name, e.target.value)}
          handleBlur={() => this.saveAddressInfo('address2')}
          displayError={isDirty('address2') && displayError('address2')}
          errorMessages={errorMessage('address2')}
        />
        <Grid>
          <Grid.Column width={9}>
            <InlineTextBoxField
              id="City"
              title="City"
              label="City"
              name="city"
              width={10}
              value={_.get(this.state.model, 'city')}
              maxLength={81}
              handleChange={(e) => handleChange(e.target.name, e.target.value)}
              handleBlur={() => this.saveAddressInfo('city')}
              displayError={isDirty('city') && displayError('city')}
              errorMessages={errorMessage('city')}
            />
          </Grid.Column>
          <Grid.Column width={4}>
            <InlineSelect
              placeholder="State"
              id="State"
              label="State/territory"
              search
              selection
              title="State"
              name="state"
              value={_.get(this.state.model, 'state')}
              options={STATE_OPTIONS}
              handleChange={(e) => handleChange(e.target.name, e.target.value)}
              handleBlur={() => this.saveAddressInfo('state')}
              displayError={isDirty('state') && displayError('state')}
              errorMessages={errorMessage('state')}
            />
          </Grid.Column>
        </Grid>
        <Grid>
          <Grid.Column width={5}>
            <InlineTextBoxField
              id="zipCode"
              title="Zip code"
              label="Zip code"
              name="zip"
              value={_.get(this.state.model, 'zip')}
              maxLength={6}
              handleChange={(e) =>
                handleChange(e.target.name, onlyAllowNumbers(e.target.value))
              }
              handleBlur={() => this.saveAddressInfo('zip')}
              displayError={isDirty('zip') && displayError('zip')}
              errorMessages={errorMessage('zip')}
            />
          </Grid.Column>
          <Grid.Column width={3}>
            <InlineTextBoxField
              id="zipExtension"
              title="Zip extension"
              label="Zip extension"
              name="zipExtension"
              value={_.get(this.state.model, 'zipExtension')}
              maxLength={5}
              handleChange={(e) =>
                handleChange(e.target.name, onlyAllowNumbers(e.target.value))
              }
              handleBlur={() => this.saveAddressInfo('zipExtension')}
              displayError={isDirty('zipExtension') && displayError('zipExtension')}
              errorMessages={errorMessage('zipExtension')}
            />
          </Grid.Column>
        </Grid>
      </Form>
    );
  }
}

export const mapStateToProps = (state) => ({
  currentlyCollaborating: !!_.get(state, 'dynamicComponent.collaboration.roomList', ''),
});

export default connect(mapStateToProps)(connectDynamic(AddressInfo));
